import Chart from "react-apexcharts";
import { colors } from "../../global";

const AverageTimeToClose = ({ data }) => {
  const chartData = {
    categories: data.map((item) => item.month),
    series: [
      {
        name: "Average Days to Close",
        data: data.map((item) => item.avg_days_to_close),
      },
    ],
  };

  return (
    <>
      <h2 className="text-lg font-semibold mb-4">Average Time to Close</h2>
      <Chart
        options={{
          chart: { type: "line", toolbar: { show: false } },
          stroke: { curve: "smooth", width: 3 },
          xaxis: {
            categories: chartData.categories,
            labels: { style: { fontSize: "12px" } },
          },
          yaxis: {
            title: { text: "Average Days" },
            labels: {
              formatter: (val) => Math.round(val), 
            },
          },
          colors: [colors.primary],
          markers: { size: 4 },
          tooltip: {
            y: {
              formatter: (val) => `${val.toFixed(1)} days`, 
            },
          },
          dataLabels: {
            enabled: true,
            formatter: (val) => `${val.toFixed(1)} days`,
            offsetY: -10,
            style: {
              fontSize: "12px",
              fontWeight: "bold",
              colors: [colors.primary],
            },
          },
        }}
        series={chartData.series}
        type="line"
        height={300}
      />
    </>
  );
};

export default AverageTimeToClose;
